import { useEffect } from "react";
import type { Event } from "stream-chat";
import { DefaultStreamChatGenerics, useChatContext } from "stream-chat-react";

export const useChannelNewMessageListener = <
  StreamChatGenerics extends DefaultStreamChatGenerics = DefaultStreamChatGenerics
>(
  channelId: string | undefined,
  onNewMessage: (event: Event<StreamChatGenerics>) => void
): void => {
  const { client } = useChatContext<StreamChatGenerics>(
    "useChannelNewMessageListener"
  );

  useEffect(() => {
    if (!channelId || !client) {
      return;
    }

    const channel = client.channel("messaging", channelId);
    const subscription = channel.on("message.new", onNewMessage);

    return () => subscription.unsubscribe();
  }, [client, channelId, onNewMessage]);
};
